import { HasPermission } from '@shared/components';
import { useParams } from 'react-router-dom';

import {
  EmployeesProfileAssignEmployees,
  EmployeesProfileServices,
  EmployeesProfileHeader,
} from '../containers';
import { EmployeesProfileMaxAmountCard } from '../containers/employees-profile-max-amount-card';
import { EmployeesProfilePicker } from '../containers/employees-profile-picker';
import { useEmployeesProfile } from '../hooks';

export const EmployeesProfile = () => {
  const { profileId } = useParams();
  const { employeeProfile, isLoading } = useEmployeesProfile(profileId);

  return (
    <HasPermission permissionFeature="EMPLOYEES_PROFILE" permissionType="READ">
      <EmployeesProfileHeader />

      <div className="grid grid-cols-3 gap-6">
        <EmployeesProfilePicker data={employeeProfile} isLoading={isLoading} />
        <EmployeesProfileMaxAmountCard
          className="col-span-2"
          data={employeeProfile}
          isLoading={isLoading}
        />
      </div>

      <div className="grid grid-cols-2 gap-6 mt-6">
        <HasPermission permissionFeature="EMPLOYEES_PROFILE_MANAGE_SERVICES" permissionType="READ">
          <EmployeesProfileServices data={employeeProfile} key={profileId} />
        </HasPermission>

        <HasPermission
          permissionFeature="EMPLOYEES_PROFILE_ASSIGN_EMPLOYEES_TO_PROFILE"
          permissionType="READ"
        >
          <EmployeesProfileAssignEmployees data={employeeProfile} />
        </HasPermission>
      </div>
    </HasPermission>
  );
};
